import { FuseNavigationItem } from '@fuse/components/navigation';
export const APP_PLATFORM_TYPES = {
    Web: 'web',
    Mobile: 'mobile',
    Both: 'both',
} as const;

export type AppPlatform = typeof APP_PLATFORM_TYPES[keyof typeof APP_PLATFORM_TYPES];

interface AppNavigationMeta {
    /** Which platforms should see this item */
    platform: AppPlatform; // default: 'both'
    roles?: string[];
    /** When true, item is hidden unless AppUser.hasOfficeAccess === true */
    requiresOfficeAccess?: true;
    /**
     * When true, item is hidden inside the installed Capacitor app
     * (Capacitor.isNativePlatform()), regardless of `platform`/screen width.
     * The app is scoped to the request workflow only — see NativeAppGuard.
     */
    hiddenInApp?: true;
}

export interface AppNavigationItem extends FuseNavigationItem {
    meta?: AppNavigationMeta;
}

export interface Navigation {
    compact: FuseNavigationItem[];
    default: FuseNavigationItem[];
    futuristic: FuseNavigationItem[];
    horizontal: FuseNavigationItem[];
}
